import { IRequestFormConfig } from '../interfaces/request/request-form-config.interface';

export const OUTFIT_2D_CONFIG: IRequestFormConfig = {
  canOnlyBeDrafted: false,
  files: [],
};
